import ActionButton from 'components/ActionButton';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import qs from 'query-string';
import { DISCOUNT_TYPES, sanitizeFilterObject } from 'utils';
import DropDown from 'components/FormFields/dropdown';

const Filter = props => {
  const [code, setCode] = useState<string>('');
  const [type, setType] = useState<string>('');
  const [discountId, setDiscountId] = useState<string>('');

  useEffect(() => {
    const {
      code,
      type,
      discountId,
    } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });

    setCode(code?.toString() || '');
    setType(type?.toString() || '');
    setDiscountId(discountId?.toString() || '');
  }, []);

  const resetFilter = () => {
    setCode('');
    setType('');
    setDiscountId('');
    let filterData: Record<string, any> = {
      code: '',
      type: '',
      discountId: '',
    };
    filterData = sanitizeFilterObject(filterData);
    props.onSubmit(filterData);
  };

  const handleSubmit = () => {
    let filterData: Record<string, any> = {
      code,
      type,
      discountId,
    };
    filterData = sanitizeFilterObject(filterData);
    props.onSubmit(filterData);
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Discount Type</div>
        <DropDown value={type} onChange={(e) => setType(e)} options={DISCOUNT_TYPES} />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Discount ID</div>
        <input
          className={'form-control'}
          value={discountId}
          onChange={e => setDiscountId(e.target.value)}
        />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Discount Code</div>
        <input
          className={'form-control'}
          value={code}
          onChange={e => setCode(e.target.value)}
        />
      </div>
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;